/**
 * Sightseeing style — mirrors iOS SightseeingStyle (AISuggestionModels).
 */

export type SightseeingStyle =
  | 'no_preference'
  | 'independent'
  | 'self_guided'
  | 'small_group'
  | 'large_group'
  | 'private_guide';

export function fromStoredSightseeingStyle(
  value: string | null | undefined
): SightseeingStyle {
  const v = String(value ?? '').trim();
  if (
    v === 'independent' ||
    v === 'self_guided' ||
    v === 'small_group' ||
    v === 'large_group' ||
    v === 'private_guide' ||
    v === 'no_preference'
  ) {
    return v;
  }
  return 'no_preference';
}

/** Small/large group and private guide get a tour every other slot suggestion. */
export function usesFrequentTourInterleaving(style: SightseeingStyle): boolean {
  return (
    style === 'small_group' || style === 'large_group' || style === 'private_guide'
  );
}

/** 1-based position in the interleaved suggestion list (2, 4, 6… or 2, 5, 8…). */
export function isTourSlotPosition(
  style: SightseeingStyle,
  oneBasedPosition: number
): boolean {
  if (oneBasedPosition < 2) return false;
  if (usesFrequentTourInterleaving(style)) {
    return oneBasedPosition % 2 === 0;
  }
  return (oneBasedPosition - 2) % 3 === 0;
}
